import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header"; // Importe o Header
import Home from "./Home";
import About from "./pages/About";
import ProjectsPage from "./pages/Projects"; // Nova página para Projects
import News from "./pages/News";
import ContactPage from "./pages/ContactPage";
import Footer from "./components/Footer"
import ProjectsEstudio from "./pages/Projects-estúdio"
import ProjectsRadio from "./pages/Projects-rádios"
import ProjectsAeroporto from "./pages/Projects-aeroporto"
import ProjectsIbirapuera from "./pages/Projects-ibirapuera"
import ProjectsBanco from "./pages/Projects-banco"
import ProjectsProvedor from "./pages/Projects-provedores"
import ProjectsUsinas from "./pages/Projects-usina"
import ProjectsMineração from "./pages/Projects-mineracao"
import ProjectsPetroleo from "./pages/Projects-petroleo"
import ProjectsAllianz from "./pages/Projects-allianz"
import ProjectsTransolimpica from "./pages/Projects-transolimpica"
import ProjectsVelodromo from "./pages/Projects-velodromo"
import ProjectsMaracanã from "./pages/Projects-maracana"
import WhitelabelProductPage from "./pages/Whitelabel-Products"
import Products from "./components/Products"
import ScrollToTop from "./components/ScrollToTop"
import ProductTypePage from "./pages/ProductType";
import Info from "./pages/Products-information"
import WhatsappButton from "./components/WhatsappButton";
import "./assets/common/fonts.css"

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header /> {/* Header incluído aqui */}
      <WhatsappButton 
          phoneNumber="551132012009" 
          message="Olá! Gostaria de saber mais sobre seus serviços."
      />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<ProjectsPage />} /> 
        <Route path="/projects-estudio" element={<ProjectsEstudio />} />
        <Route path="/projects-radios" element={<ProjectsRadio/>} />
        <Route path="/projects-aeroporto" element={<ProjectsAeroporto/>} />
        <Route path="/projects-ibirapuera" element={<ProjectsIbirapuera/>} />
        <Route path="/projects-bancocentral" element={<ProjectsBanco/>} />
        <Route path="/projects-provedores" element={<ProjectsProvedor/>} />
        <Route path="/projects-usinas" element={<ProjectsUsinas/>} />
        <Route path="/projects-mineracao" element={<ProjectsMineração/>} />
        <Route path="/projects-plataformas" element={<ProjectsPetroleo/>} />
        <Route path="/projects-allianz" element={<ProjectsAllianz/>} />
        <Route path="/projects-transolimpica" element={<ProjectsTransolimpica/>} />
        <Route path="/projects-velodromo" element={<ProjectsVelodromo/>} />
        <Route path="/projects-maracana" element={<ProjectsMaracanã/>} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/produto/:name" element={<Info />} />
        <Route path="/produtos/:category" element={<WhitelabelProductPage />} />
        <Route path="/produtos/:category/:type" element={<ProductTypePage />} />

        <Route path="/categoria/:category" element={<WhitelabelProductPage />} />
      </Routes>
      <Footer/>
    </Router>
  );
};

export default App; 